import { initialState, AuthState } from './selectors';
import * as actions from './actions';

export default (
  state: AuthState = initialState,
  action: actions.AuthAction,
) => {
  switch (action.type) {
    case actions.AUTH_ACTIONS.AUTH_RELOADED: {
      const {
        payload: { user },
      } = action as actions.AuthReloaded;
      return {
        ...state,
        user,
        loggedIn: true,
      };
    }

    case actions.AUTH_ACTIONS.LOGIN_REQUESTED: {
      return { ...state, loading: true };
    }

    case actions.AUTH_ACTIONS.LOGIN_FAILED: {
      const { error } = action as actions.LoginFailed;
      return {
        ...state,
        error,
        loading: false,
      };
    }

    case actions.AUTH_ACTIONS.LOGIN_SUCCEEDED: {
      const {
        payload: { user },
      } = action as actions.LoginSucceeded;
      return {
        ...state,
        user,
        loggedIn: true,
        loading: false,
      };
    }

    case actions.AUTH_ACTIONS.LOGOUT_SUCCEEDED: {
      return {
        ...state,
        loggedIn: false,
        loading: false,
      };
    }

    case actions.AUTH_ACTIONS.LOGOUT_FAILED: {
      const { error } = action as actions.LogoutFailed;
      return {
        ...state,
        error,
      };
    }

    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/auth/reducer.ts